import { __exports as liveSiteClient } from './_virtual-liveSiteClient.js';
import { __require as requireLogger } from './vp-js-token-engine-build-infrastructure-logger.js';

var hasRequiredLiveSiteClient;

function requireLiveSiteClient () {
	if (hasRequiredLiveSiteClient) return liveSiteClient;
	hasRequiredLiveSiteClient = 1;

	Object.defineProperty(liveSiteClient, "__esModule", {
	  value: true
	});
	liveSiteClient.getHost = void 0;
	var _logger = requireLogger();
	const liveSiteUrl = 'https://livesite.jetstream.vpsvc.com/';
	const getHost = async (locale, tenant) => {
	  let sites;
	  try {
	    const response = await fetch(liveSiteUrl);
	    const data = await response.json();
	    sites = data.tenant[tenant] && data.tenant[tenant].sites;
	    for (const site in sites) {
	      if (sites[site].primaryLanguage === locale || sites[site].supportedLanguages.includes(locale)) {
	        return "https://".concat(sites[site].canonicalDomain);
	      }
	    }
	    throw new Error("Canonical domain not found for tenant ".concat(tenant, " and ").concat(locale));
	  } catch (e) {
	    _logger.logger.error("The request for tenant ".concat(tenant, " and ").concat(locale, " to url: ").concat(liveSiteUrl, ". Returned error ").concat(e.stack), {
	      contextData: {
	        stack: e.stack,
	        culture: locale,
	        tenant
	      }
	    });
	    throw e;
	  }
	};
	liveSiteClient.getHost = getHost;
	
	return liveSiteClient;
}

export { requireLiveSiteClient as __require };
//# sourceMappingURL=vp-js-token-engine-build-services-liveSiteClient.js.map
